import { create } from 'zustand'

interface PositionsAccordionState {
  openRoles: Array<string>
  openLevels: Array<string>
  setAccordionState: (roles: Array<string>, levels: Array<string>) => void
  clearAccordionState: () => void
}

export const usePositionsAccordionStore = create<PositionsAccordionState>(
  (set) => ({
    openRoles: [],
    openLevels: [],
    setAccordionState: (roles, levels) =>
      set({ openRoles: roles, openLevels: levels }),
    clearAccordionState: () => set({ openRoles: [], openLevels: [] }),
  }),
)
